/**
 * APUFUNKTIOT: Numeroiden turvallinen haku
 */
const getVal = (el) => el ? (parseInt(el.value) || 0) : 0;
const getTextNum = (el) => el ? (parseFloat(el.textContent.replace(',', '.')) || 0) : 0;

/**
 * Tuotelistan avaaminen/sulkeminen
 */
function initProductTableAccordion() {
  document.querySelectorAll(".product-table-list__heading").forEach(heading => {
    heading.addEventListener('click', () => {
      const content = heading.nextElementSibling;
      if (content) {
        content.classList.toggle('table-open');
        heading.classList.toggle('border-radius-zero');
      }
    });
  });
}

/**
 * Päivittää popupin yhteissummat (Hinta ja kpl)
 */
function updateGrandTotals() {
  let grandTotalPrice = 0;
  let grandTotalQuantity = 0;
  const productRows = document.querySelectorAll(".product-table-list__product-row");
  const popup = document.getElementById("productTableListPopup");

  productRows.forEach(row => {
    const totalPriceEl = row.querySelector("#totalPrice");
    const newQtyEl = row.querySelector("#newQuantity");
    const usedQtyEl = row.querySelector("#usedQuantity");

    grandTotalPrice += getTextNum(totalPriceEl);
    grandTotalQuantity += (getVal(newQtyEl) + getVal(usedQtyEl));
  });

  const priceDisplay = document.getElementById("popupTotalPrice");
  const qtyDisplay = document.getElementById("popupTotalQuantity");

  if (priceDisplay) priceDisplay.textContent = `${grandTotalPrice.toFixed(0)}€`;
  if (qtyDisplay) qtyDisplay.textContent = grandTotalQuantity;

  if (popup) {
    popup.style.display = grandTotalPrice > 0 ? "block" : "none";
  }
}

/**
 * Päivittää yksittäisen rivin välisumman (Laskenta taustalla)
 */
function updateRowTotal(row) {
  const nPrice = getTextNum(row.querySelector("#newPrice"));
  const uPrice = getTextNum(row.querySelector("#usedPrice"));
  const nQty = getVal(row.querySelector("#newQuantity"));
  const uQty = getVal(row.querySelector("#usedQuantity"));

  const totalPrice = (nQty * nPrice) + (uQty * uPrice);
  const totalQty = nQty + uQty;

  const totalPriceEl = row.querySelector("#totalPrice");
  if (totalPriceEl) totalPriceEl.textContent = totalPrice.toFixed(0);

  row.style.backgroundColor = totalQty > 0 ? "rgba(175, 225, 175, 0.4)" : "";
}

/**
 * Muodostaa tekstiviestin/yhteenvedon tekstialueeseen
 */
function updateContactFormText() {
  const tableRows = document.querySelectorAll('.jsProductTableListRow');
  const textArea = document.getElementById('ContactForm-body-products');
  if (!textArea) return;

  let details = '';
  let totalAllPrice = 0;
  let totalAllQty = 0;

  const url = window.location.href;
  const lang = url.includes("/sv/") ? "sv" : url.includes("/en/") ? "en" : "fi";

  const labels = {
    fi: { label: "Tarrallisia", noLabel: "Tarrattomia", unit: "kpl", grandQty: "Tuotteita yhteensä", grandPrice: "Hinta yhteensä" },
    sv: { label: "Med etikett", noLabel: "Utan etikett", unit: "st", grandQty: "Antal totalt", grandPrice: "Pris totalt" },
    en: { label: "With label", noLabel: "Without label", unit: "pcs", grandQty: "Total quantity", grandPrice: "Total price" }
  }[lang];

  tableRows.forEach(row => {
    const name = row.querySelector('#productName')?.textContent.trim() || "";
    const nPrice = getTextNum(row.querySelector('#newPrice'));
    const uPrice = getTextNum(row.querySelector('#usedPrice'));
    const nQty = getVal(row.querySelector('#newQuantity'));
    const uQty = getVal(row.querySelector('#usedQuantity'));
    const rowTotal = (nQty * nPrice) + (uQty * uPrice);

    if (nQty > 0 || uQty > 0) {
      details += `${name}:\n`;
      if (nQty > 0) details += `- ${labels.label}: ${nQty} ${labels.unit} (${nPrice}€/${labels.unit})\n`;
      if (uQty > 0) details += `- ${labels.noLabel}: ${uQty} ${labels.unit} (${uPrice}€/${labels.unit})\n`;
      details += `\n`; 

      totalAllPrice += rowTotal;
      totalAllQty += (nQty + uQty);
    }
  });

  if (totalAllQty > 0) {
    details += `------------------\n`;
    details += `${labels.grandQty}: ${totalAllQty}\n`;
    details += `${labels.grandPrice}: ${totalAllPrice}€`;
  }

  textArea.value = details;
}

/**
 * TAPAHTUMAKUUNTELIJAT
 */
function initEventListeners() {
  ["closeProductTableListPopupButton", "toContactForm"].forEach(id => {
    const btn = document.getElementById(id);
    if (btn) {
      btn.addEventListener("click", () => {
        const popup = document.getElementById("productTableListPopup");
        if (popup) popup.style.display = "none";
      });
    }
  });

  document.querySelectorAll(".product-table-list__product-row").forEach(row => {
    row.querySelectorAll("input").forEach(input => {
      input.addEventListener("input", () => {
        updateRowTotal(row);
        updateGrandTotals();
        updateContactFormText();
      });
    });
  });
}

// Käynnistys
document.addEventListener("DOMContentLoaded", () => {
  initProductTableAccordion();
  initEventListeners();
  updateGrandTotals();
});

// Kuva-popup
function openImagePopup(imageElement) {
  const imageUrl = imageElement.getAttribute("src");
  const popup = window.open("", "_blank", "width=600,height=600");
  popup.document.write(`<body style="margin:0;display:flex;align-items:center;justify-content:center;background:#000;"><img src="${imageUrl}" style="max-width:100%;max-height:100%;" /></body>`);
}